<template lang="pug">
  .details.column.width-100
    language-selector.language-selector(
      v-if='availableLanguages && availableLanguages.length > 0'
      :languages='availableLanguages'
      @change-resource-locale='reloadProgram'
      :disabled='availableLanguages.length === 1'
      inner
    )
    h3.title-medium.m-bottom-1(v-if='!!activeProgramLanguage.rationale')
      | {{ innerI18n.t('detailProgram.foundation') }}
    p.md-content.md-small.width-100.m-bottom-5(
      v-if='!!activeProgramLanguage.rationale'
      v-html='md.render(activeProgramLanguage.rationale)'
    )
    h3.title-medium.m-bottom-1(v-if='!!activeProgramLanguage.pedagogicalObjective')
      | {{ innerI18n.t('detailProgram.pedagogicalObjective') }}
    p.md-content.md-small.width-100.m-bottom-5(
      v-if='!!activeProgramLanguage.pedagogicalObjective'
      v-html='md.render(activeProgramLanguage.pedagogicalObjective)'
    )
    .row.start
      a.secondary-button.small.with-icon.max-width-none.m4-right-5(
        target='_blank' rel='noreferrer noopener'
        :href='activeProgramLanguage.summaryLink'
        v-if='activeProgramLanguage.summaryLink'
      )
        simple-svg.blue-icon.m-right-1(:filepath='downloadIcon' :width='"15px"' :height='"15px"')
        | {{ innerI18n.t('detailProgram.downloadLink') }}
      button.primary-button.with-icon.max-width-none(
        type='button'
        @click='showElement({ element: "askForInformationModal" })'
        v-if='isNotPurchased && isApproved'
      )
        simple-svg.white-icon.m-right-1(:filepath='addIcon' :width='"20px"' :height='"20px"')
        | {{ innerI18n.t('detailProgram.addProgram') }}
      button.primary-button.with-icon.max-width-none(
        type='button'
        @click='showElement({ element: "askForInformationModal" })'
        v-if='isComingSoon'
      )
        simple-svg.white-icon.m-right-1(:filepath='infoIcon' :width='"20px"' :height='"20px"')
        | {{ innerI18n.t('detailProgram.askInfo') }}
      button.m-left-auto.secondary-button.small.with-icon.max-width-none(
        type='button'
        @click='downloadPdfSummary'
        v-if='showDownloadPdfSummary'
      )
        simple-svg.blue-icon.m-right-1(:filepath='downloadIcon' :width='"15px"' :height='"15px"')
        | {{ innerI18n.t('detailProgram.downloadPdfSummary') }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { innerI18n } from '../../main'
import infoIcon from '@/assets/ic_info.svg'
import addIcon from '@/assets/ic_more.svg'
import downloadIcon from '@/assets/ic_download.svg'
import LanguageSelector from '../LanguageSelector'
import MarkdownIt from 'markdown-it'
import { languagesCodesToString } from '../../constants/languages'
import { educationalProgramLanguageStatus, educationalProgramStatus } from '../../utils/constants'
import { downloadFile } from '../../utils/download'

export default {
  components: { LanguageSelector },
  data() {
    return {
      downloadIcon,
      innerI18n,
      addIcon,
      infoIcon,
      md: new MarkdownIt({ html: true })
    }
  },
  computed: {
    ...mapState({
      innerLocale: state => state.behavior.innerLocale,
      program: state => state.educationalProgram.educationalProgram,
      customFields: state => state.userInfo.customFields
    }),
    showDownloadPdfSummary() {
      return this.customFields.visibleDownloadableSummary
    },
    availableLanguages() {
      return Object.keys(this.program.activatedLanguages)
        .filter(key => this.program.activatedLanguages[key] !== educationalProgramLanguageStatus.hidden)
    },
    isComingSoon() {
      return this.program.activatedLanguages[this.innerLocale] === educationalProgramLanguageStatus.comingSoon
    },
    isApproved() {
      return this.program.activatedLanguages[this.innerLocale] === educationalProgramLanguageStatus.approved
    },
    isNotPurchased() {
      return this.program.purchasedStatus === educationalProgramStatus.notPurchased
    },
    activeProgramLanguage() {
      return this.program.localizedEducationalPrograms.find(pr => languagesCodesToString[pr.locale] === this.innerLocale)
    }
  },
  methods: {
    ...mapActions([
      'getEducationalProgram',
      'showElement',
      'generateEducationalProgramPdf'
    ]),
    reloadProgram(locale) {
      this.getEducationalProgram({ id: this.$route.params.id, locale: locale || this.locale })
    },
    async downloadPdfSummary() {
      const { success, data } = await this.generateEducationalProgramPdf({
        id: this.$route.params.id,
        locale: this.innerLocale
      })
      if (success) {
        const blob = new Blob([data], { type: 'application/pdf' })
        const blobUrl = URL.createObjectURL(blob)
        downloadFile(blobUrl, `${this.activeProgramLanguage.name.replaceAll(' ', '-')}.pdf`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.language-selector{
  position: absolute;
  top: 20px;
  right: 20px;
}

.details {
  background-color: $white;
  border-radius: 8px;
  border: 1px solid $black;
  margin-top: -60px;
  padding: 48px;
  position: relative;
}
</style>
